/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import { useCart } from "./useCart";
import { useConfig } from "../lib/react-query/useConfig";
import { computeItemsBreakdown } from "../utils/computeItemsBreakdown";

export const useCartSummary = (linesOverride) => {
  const { lines: cartLines } = useCart();
  const lines = linesOverride ?? cartLines;
  const { data: config } = useConfig();
  const priceIncludesTax = !!config?.price_includes_tax;

  return useMemo(() => {
    const items = lines.map((line) => ({
      qty: line.params.qty ?? 1,
      price: line.snapshot?.price ?? 0,
      tax: line.snapshot?.tax,
      currency: line.snapshot?.currency,
    }));
    return computeItemsBreakdown(items, { priceIncludesTax });
  }, [lines, priceIncludesTax]);
};
